import { RESTORE_GAME as SOCKET_RESTORE_GAME } from '../../events/DashboardToServer'
import { DELETE_SNAPSHOT as SOCKET_DELETE_SNAPSHOT } from '../../events/DashboardToServer'

export const RESTORE_GAME = 'RESTORE_GAME'
export const DELETE_SNAPSHOT = 'DELETE_SNAPSHOT'
export const GAME_RESTORED = 'GAME_RESTORED'
export const SNAPSHOT_DELETED = 'SNAPSHOT_DELETED'


export const snapshot = (state = null, action) => {
    switch (action.type) {
    
        case SNAPSHOT_DELETED:
            return action.game_id

        case GAME_RESTORED:
            return action.game_id

        default:
            return state
    }
}

export const snapshotDeleted = (game_id) => {
    return { type: SNAPSHOT_DELETED,  game_id}
}

export const gameRestored = (game_id) => {
    console.log("GIOCO RECUPERATO!")
    return { type: GAME_RESTORED, game_id}
}

export const restoreGame = (socket, game_id) => {
    socket.emit(SOCKET_RESTORE_GAME, game_id);
    return { type: RESTORE_GAME,  game_id}
}

export const deleteSnapshot = (socket, game_id) => {
    socket.emit(SOCKET_DELETE_SNAPSHOT, game_id);
    return { type: DELETE_SNAPSHOT, game_id}
}


// WEBPACK FOOTER //
// ./src/reducers/snapshot/index.js